import sortDataInSameOrderAsCustomEntities from "./sortDataInSameOrderAsCustomEntities";
import TYPES from "./TYPES";

export default (state, action) => {
    switch (action.type) {
        case TYPES.DATA_LOADED: {
            return {
                ...state,
                loading: false,
                entitiesLoaded: true,
                data: action.payload.map(item => ({
                    ...item,
                    expanded: false,
                    selected: item.selected || !!item.requiredInAlice,
                    numRequiredAttributes: item.attributes.filter(attr => attr.requiredInAlice === "true").length,
                    attributes: item.attributes.map((attr) => ({
                        ...attr,
                        selected: !!item.requiredInAlice
                    }))
                })),
            }
        }
        case TYPES.NO_ENTITY_RECOMMENDED:
            return {
                ...state,
                showNoEntitiesMessage: true
            }
        case TYPES.ENTITY_SELECTED: {
            const newData = state.data.map(element => {
                if (element.id === action.payload.id) {
                    const newAttributes = element.attributes.map((attr, index) => ({
                        ...attr, selected: index < 20
                    }));
                    return {
                        ...element,
                        selected: true,
                        attributes: newAttributes
                    };
                };

                return element;
            })
            return {
                ...state,
                data: newData
            }
        }
        case TYPES.ENTITY_DESELECTED: {
            const newData = state.data.map(element => {
                if (element.id === action.payload.id) {
                    const newAttributes = element.attributes.map(attr => ({
                        ...attr, selected: false
                    }))
                    return {
                        ...element,
                        selected: false,
                        attributes: newAttributes
                    }
                };

                return element;
            });

            return {
                ...state,
                data: newData
            }
        }
        case TYPES.ENTITY_EXPANDED: {
            const data = state.data.map((item) => {
                if (item.id === action.payload.id) {
                    return {
                        ...item,
                        expanded: !item.expanded
                    }
                }
          
                return item;
            });
            return {
                ...state,
                data
            }
        }
        case TYPES.ATTRIBUTE_SELECTED: {
            const { entityId, attributeId } = action.payload;
            const newData = state.data.map(element => {
                if (element.id === entityId) {
                    const newAttributes = element.attributes.map(attr => {
                        if (attr.id === attributeId) {
                            return {
                                ...attr,
                                selected: true
                            }
                        }

                        return attr;
                    });

                    return {
                        ...element,
                        selected: true,
                        attributes: newAttributes
                    }
                };

                return element;
            })
            return {
                ...state,
                data: newData
            }
        }
        case TYPES.ATTRIBUTE_DESELECTED: {
            const { entityId, attributeId } = action.payload;
            const newData = state.data.map(element => {
                if (element.id === entityId) {
                    const newAttributes = element.attributes.map(attr => {
                        if (attr.id === attributeId) {
                            return {
                                ...attr,
                                selected: false
                            }
                        }

                        return attr;
                    });

                    const selected = newAttributes.some(attr => attr.selected);

                    return {
                        ...element,
                        selected,
                        attributes: newAttributes
                    }
                }

                return element;
            })
            return {
                ...state,
                data: newData
            }
        }
        case TYPES.RELATIONS_LOADED:
            return {
                ...state,
                relationsLoaded: true,
                relations: action.payload.map((relation, index) => ({
                    ...relation,
                    id: index,
                    // This is done to retain selection when
                    // used in create project or workspace
                    // as the relations are loaded when the entity selection changes
                    selected: relation.selected || false
                }))
            }
        case TYPES.RELATION_SELECTED:
            return {
                ...state,
                relations: state.relations.map(relation => {
                    if (relation.id === action.payload.id) {
                        return {
                            ...relation,
                            selected: true
                        }
                    }

                    return relation;
                })
            }
        case TYPES.RELATION_DESELECTED:
            return {
                ...state,
                relations: state.relations.map(relation => {
                    if (relation.id === action.payload.id) {
                        return {
                            ...relation, selected: false
                        }
                    }

                    return relation;
                })
            }
        case TYPES.COLD_START: {
            return {
                ...state,
                isColdStart: true
            }
        }
        case TYPES.NEXT_ENTITY_SET_LOADED: {
            return {
                ...state,
                data: [
                    ...state.data,
                    ...action.payload
                ]
            }
        }
        case TYPES.START_LOADING: {
            return {
                ...state,
                loading: true
            }
        }
        case TYPES.ENTITY_RECOMMENDED:
            return {
                ...state,
                showNoEntitiesMessage: false
            }
        case TYPES.TOGGLE_SHOW_MORE_OPTION:
            return {
                ...state,
                isShowMoreOptionVisible: !state.isShowMoreOptionVisible
            }
        case TYPES.RELATIONS_SELECTED:
            debugger;
            return {
                ...state,
                relations: state.relations.map(relation => ({
                    ...relation,
                    selected: true
                }))
            }
        case TYPES.RELATIONS_DESELECTED:
            return {
                ...state,
                relations: state.relations.map(relation => ({
                    ...relation,
                    selected: false
                }))
            }
        case TYPES.TOGGLE_SELECT_ALL_ENTITIES: {
            // select all entities if none or some are selected
            // else deselect all entities
            const selected = state.data.every(entity => entity.selected);
            const newData = state.data.map(entity => ({
                ...entity,
                selected: entity.requiredInAlice === "true" ? true : !selected,
                attributes: entity.attributes.map((attr, index) => {
                    let isSelected = attr.selected;
                    if (entity.requiredInAlice === "true" && entity.numRequiredAttributes === 0) {
                        isSelected = index === 0;
                    } else if (attr.requiredInAlice === "true") {
                        isSelected = true;
                    } else {
                        isSelected = !entity.selected && index < 20;
                    }
                    return {
                        ...attr,
                        selected: isSelected
                    }
                })
            }));
            return {
                ...state,
                data: newData   
            }
        }
        case TYPES.TOGGLE_SHOW_LIBRARY_ATTRIBUTES: {
            // toggle showLibraryAttributes
            return {
                ...state,
                showLibraryAttributes: !state.showLibraryAttributes
            }
        }
        case TYPES.TOGGLE_SHOW_ORGANIZATION_ATTRIBUTES: {
            // toggle showOrganizationAttributes
            return {
                ...state,
                showOrganizationAttributes: !state.showOrganizationAttributes
            }
        }
        case TYPES.CUSTOM_ENTITIES_CHANGED: {
            const customEntities = action.payload;
            const newData = sortDataInSameOrderAsCustomEntities(state.data, customEntities).map(entity => {
                const customEntity = customEntities.some(customEntity => customEntity.name.toLowerCase() === entity.name.toLowerCase());
                return {
                    ...entity,
                    selected: customEntity,
                    attributes: entity.attributes.map((attr, index) => ({
                        ...attr,
                        selected: customEntity && index < 20
                    }))
                }
            });

            return {
                ...state,
                data: newData
            }
        }
        case TYPES.SET_CREATING_DATA: {
            return {
                ...state,
                creatingData: action.payload
            }
        }
        default:
            return state;
    }
}